import logosm from "../assets/images/logo-sm.png";
import avatar1 from "../assets/images/users/avatar-1.jpg";
import avatar2 from "../assets/images/users/avatar-2.jpg";
import avatar3 from "../assets/images/users/avatar-3.jpg";
import avatar4 from "../assets/images/users/avatar-4.jpg";
import avatar5 from "../assets/images/users/avatar-5.jpg";
import avatar6 from "../assets/images/users/avatar-6.jpg";
import avatar7 from "../assets/images/users/avatar-7.jpg";
import avatar8 from "../assets/images/users/avatar-8.jpg";
import avatar9 from "../assets/images/users/avatar-9.jpg";

const usersList = [
    {
        id:0,
        memberName : "Demo Admin",
        role: "admin",
        memberImage: logosm,
        email:"admin@demo.com.tr",
        mobile:"+90 535 123 45 67",
        registeredOn :"20 Sep, 2022",
        active:true
    },
    {
        id:1,
        memberName :"Burcu Taskan Demirkok",
        memberImage:avatar1,
        role: "store_manager",
        email:"burcu.taskan@demo.com.tr",
        mobile:"+90 535 123 45 67",
        registeredOn :"20 Sep, 2022",
        active:true
    },
    {
        id:2,
        memberName :"Ilgin Kaya",
        memberImage:avatar2,
        role: "store_manager",
        email:"ilgin.kaya@demo.com.tr",
        mobile:"253-205-7394",
        registeredOn :"12 Arl, 2022",
        status:"Disabled"
    },
    {
        id:3,
        memberName :"Cagatay Akin Baser",
        memberImage:avatar3,
        role: "store_manager",
        email:"cagatay.baser@demo.com.tr",
        mobile:"832-330-4300",
        registeredOn :"28 Mar, 2022",
        active:true
    },
    {
        id:4,
        memberName :"Halime Kaya",
        memberImage:avatar4,
        role: "store_manager",
        email:"halime.kaya@demo.com.tr",
        mobile:"+90 535 123 45 67",
        registeredOn :"20 Sep, 2022",
        active:true
    },
    {
        id:5,
        memberName :"Cigdem Sayan",
        memberImage:avatar5,
        role: "store_manager",
        email:"cigdem.sayam@demo.com.tr",
        mobile:"770-800-9825",
        registeredOn :"23 Aug, 2022",
        active:true
    },
    {
        id:6,
        memberName :"Tolga Kaskati",
        memberImage:avatar6,
        role: "store_manager",
        email:"tolga.kaskati@demo.com.tr",
        mobile:"804-509-5073",
        registeredOn :"18 Sep, 2022",
        status:"Disabled"
    },
    {
        id:7,
        memberName :"Baris Ersoy",
        memberImage:avatar7,
        role: "store_manager",
        email:"baris.ersoy@demo.com.tr",
        mobile:"205-243-9746",
        registeredOn :"12 Feb, 2022",
        active:true
    },
    {
        id:8,
        memberName :"Emre Öztuna",
        memberImage:avatar8,
        role: "store_manager",
        email:"emre.oztuna@demo.com.tr",
        mobile:"214-592-0512",
        registeredOn :"30 Nov, 2022",
        status:"Disabled"
    },
    {
        id:9,
        memberName :"Ahmet Dündar",
        memberImage:avatar9,
        role: "store_manager",
        email:"ahmet.dundar@demo.com.tr",
        mobile:"862-222-0853",
        registeredOn :"23 Sep, 2022",
        active:true
    },
    {
        id:10,
        memberName :"Berk Köksal",
        memberImage:avatar1,
        role: "store_manager",
        email:"berk.koksal@demo.com.tr",
        mobile:"407-691-4701",
        registeredOn :"16 Aug, 2022",
        active:true
    }
]

export {usersList}